export const myInfoCountries = [
  'AFGHANISTAN',
  'ALBANIA',
  'ALGERIA',
  'AMERICAN SAMOA',
  'ANDORRA',
  'ANGOLA',
  'ANGUILLA',
  'ANTIGUA',
  'ARGENTINA',
  'ARMENIA',
  'ARUBA',
  'AUSTRALIA',
  'AUSTRIA',
  'AZERBAIJAN',
  'BAHAMAS',
  'BAHRAIN',
  'BANGLADESH',
  'BARBADOS',
  'BELARUS',
  'BELGIUM',
  'BELIZE',
  'BENIN',
  'BERMUDA',
  'BHUTAN',
  'BOLIVIA',
  'BOSNIA-HERZEGOVINA',
  'BOTSWANA',
  'BRAZIL',
  'BRITISH ANTARCTIC TERRITORY',
  'BRITISH INDIAN OCEAN TERRITORY',
  'BRITISH VIRGIN ISLANDS',
  'BRUNEI',
  'BULGARIA',
  'BURKINA FASO',
  'BURUNDI',
  'CAMBODIA',
  'CAMEROON',
  'CANADA',
  'CANTON & ENDERBURY ISLANDS',
  'CAPE VERDE',
  'CAYMAN ISLANDS',
  'CENTRAL AFRICAN REPUBLIC',
  'CHAD',
  'CHANNEL ISLANDS',
  'CHILE',
  'CHINA',
  'CHRISTMAS ISLAND',
  'COCOS KEELING ISLAND',
  'COLOMBIA',
  'COMOROS',
  'CONGO',
  'COOK ISLANDS',
  'COSTA RICA',
  'CROATIA',
  'CUBA',
  'CYPRUS',
  'CZECH REPUBLIC',
  'DENMARK',
  'DJIBOUTI',
  'DOMINICA',
  'DOMINICAN REPUBLIC',
  'EAST TIMOR',
  'ECUADOR',
  'EGYPT',
  'EL SALVADOR',
  'EQUATORIAL GUINEA',
  'ERITREA',
  'ESTONIA',
  'ETHIOPIA',
  'FAEROE ISLANDS',
  'FALKLAND ISLANDS',
  'FIJI',
  'FINLAND',
  'FRANCE',
  'FRENCH GUIANA',
  'FRENCH POLYNESIA',
  'FRENCH SOUTHERN & ANTARCTIC TERRITORIES',
  'GABON',
  'GAMBIA',
  'GAZA',
  'GEORGIA',
  'GERMANY',
  'GHANA',
  'GIBRALTAR',
  'GREECE',
  'GREENLAND',
  'GRENADA',
  'GUADELOUPE',
  'GUAM',
  'GUATEMALA',
  'GUERNSEY',
  'GUINEA',
  'GUINEA-BISSAU',
  'GUYANA',
  'HAITI',
  'HEARD & MCDONALD ISLAND',
  'HONDURAS',
  'HONG KONG',
  'HONG KONG SAR',
  'HUNGARY',
  'ICELAND',
  'INDIA',
  'INDONESIA',
  'IRAN',
  'IRAQ',
  'IRELAND',
  'ISLE OF MAN',
  'ISRAEL',
  'ITALY',
  'IVORY COAST',
  'JAMAICA',
  'JAPAN',
  'JOHNSTON ISLAND',
  'JORDAN',
  'KAZAKHSTAN',
  'KENYA',
  'KIRGHIZIA',
  'KIRIBATI',
  'KOREA, NORTH',
  'KOREA, SOUTH',
  'KOSOVO',
  'KUWAIT',
  'KYRGYZSTAN',
  'LAOS',
  'LATVIA',
  'LEBANON',
  'LESOTHO',
  'LIBERIA',
  'LIBYA',
  'LIECHTENSTEIN',
  'LITHUANIA',
  'LUXEMBOURG',
  'MACAO',
  'MACAU SAR',
  'MACEDONIA',
  'MADAGASCAR',
  'MALAWI',
  'MALAYSIA',
  'MALDIVES',
  'MALI',
  'MALTA',
  'MARSHALL ISLANDS',
  'MARTINIQUE',
  'MAURITANIA',
  'MAURITIUS',
  'MAYOTTE',
  'MEXICO',
  'MIDWAY ISLANDS',
  'MOLDOVA',
  'MONACO',
  'MONGOLIA',
  'MONTENEGRO',
  'MONTSERRAT',
  'MOROCCO',
  'MOZAMBIQUE',
  'MYANMAR',
  'NAMIBIA',
  'NAURU',
  'NEPAL',
  'NETHERLANDS',
  'NETHERLANDS ANTILILLES',
  'NEW CALEDONIA',
  'NEW ZEALAND',
  'NICARAGUA',
  'NIGER',
  'NIGERIA',
  'NIUE ISLAND',
  'NORFOLK ISLAND',
  'NORWAY',
  'OMAN',
  'OTHERS',
  'PACIFIC ISLAND TRUST TERRITORY',
  'PAKISTAN',
  'PALAU',
  'PALESTINE',
  'PANAMA',
  'PANAMA CANAL ZONE',
  'PAPUA NEW GUINEA',
  'PARAGUAY',
  'PERU',
  'PHILIPPINES',
  'PITCAIRN ISLAND',
  'POLAND',
  'PORTUGAL',
  'PUERTO RICO',
  'QATAR',
  'REUNION',
  'ROMANIA',
  'RUSSIA',
  'RWANDA',
  'SAMOA',
  'SAN MARINO',
  'SAO TOME & PRINCIPE',
  'SAUDI ARABIA',
  'SENEGAL',
  'SERBIA',
  'SERBIA/MONTENEGRO',
  'SEYCHELLES',
  'SIERRA LEONE',
  'SINGAPORE',
  'SLOVAK REPUBLIC',
  'SLOVENIA',
  'SOLOMON ISLANDS',
  'SOMALIA',
  'SOUTH AFRICA',
  'SPAIN',
  'SRI LANKA',
  'ST. HELENA',
  'ST. KITTS-NEVIS',
  'ST. LUCIA',
  'ST. PIERRE & MIQUELON',
  'ST. VINCENT',
  'SUDAN',
  'SURINAME',
  'SWAZILAND',
  'SWEDEN',
  'SWITZERLAND',
  'SYRIA',
  'TAIWAN',
  'TAJIKISTAN',
  'TANZANIA',
  'THAILAND',
  'TIMOR',
  'TOGO',
  'TOKELAU ISLANDS',
  'TONGA',
  'TRINIDAD & TOBAGO',
  'TUNISIA',
  'TURKEY',
  'TURKMENISTAN',
  'TURKS & CAICOS ISLANDS',
  'TUVALU',
  'UGANDA',
  'UKRAINE',
  'UNITED ARAB EMIRATES',
  'UNITED KINGDOM',
  'UNITED STATES',
  'UNKNOWN',
  'UPPER VOLTA',
  'URUGUAY',
  'US VIRGIN ISLANDS',
  'UZBEKISTAN',
  'VANUATU',
  'VATICAN CITY STATE',
  'VENEZUELA',
  'VIETNAM',
  'WAKE ISLAND',
  'WALLIS AND FUTUNA',
  'WESTERN SAHARA',
  'YEMEN',
  'YUGOSLAVIA',
  'ZAIRE',
  'ZAMBIA',
  'ZIMBABWE',
]
